function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 24
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 24,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.97,10.1l-8.9-8.9a.684.684,0,0,0-.968,0l0,0L2.2,10.1a.689.689,0,0,0,.486,1.171H4.054V20.85a.685.685,0,0,0,.685.685H9.531a.685.685,0,0,0,.685-.685V15.716a.342.342,0,0,1,.342-.342h2.054a.342.342,0,0,1,.342.342V20.85a.685.685,0,0,0,.685.685H18.43a.685.685,0,0,0,.685-.685V11.267h1.369A.689.689,0,0,0,20.97,10.1Z",
  transform: "translate(1.108 1.006)",
  fill: "#c4c4c4"
}));

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.8b40bd07.svg";
export { ForwardRef as ReactComponent };